import feathersClient, {makeServicePlugin, BaseModel} from "@/feathers/feathers-client";
import {clearList, updateItems} from '../custom-mutations';

class MyParkedCall extends BaseModel {

  constructor(data, options) {
    super(data, options);
  }

  static modelName = 'MyParkedCall';

}

const servicePath = 'myparkedcalls';
const servicePlugin = makeServicePlugin({
  enableEvents: false,
  idField: 'parkingSpace',
  Model: MyParkedCall,
  service: feathersClient.service(servicePath),
  servicePath,
  mutations: {
    updateItems(state, items) {
      updateItems(state, items)
    },
    updateItem(state, item){
      updateItems(state, [item])
    },
    clearList(state){
      clearList(state)
    }
  }
})

export default servicePlugin;
